import * as yup from 'yup';

export const AdministrationUserCreateStep3Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    email: yup
      .string()
      .required(t('errors.missing.email'))
      .max(255, t('errors.inputTooLong'))
      .email(t('errors.invalidEmail')),
    firstName: yup
      .string()
      .required(t('errors.missing.firstName'))
      .max(100, t('errors.inputTooLong', { maxLength: '100' })),
    lastName: yup
      .string()
      .required(t('errors.missing.lastName'))
      .max(100, t('errors.inputTooLong', { maxLength: '100' })),
  });
